module.exports = __webpack_public_path__ + "static/img/logo.fb0500a4.svg";